import { useContext, useEffect } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { Popup } from 'components/popup/popup';
import { PopupLayout, PopupStore } from 'components/popup/popup.store';
import { AppContext } from 'core/context/app.context';
import { SiteConfigStore } from 'core/stores/site-config.store';

const WelcomeScreen = observer<{ template?: 'brandMissMatch' }>(({ template }) => {
  const appContext = useContext(AppContext);
  const popupStore = useLocalObservable(() => new PopupStore());

  const popupConfig = {
    template: PopupLayout.WelcomePopup,
    hasCancelButton: false,
  };

  const brandMissMatchPopupConfig = {
    template: PopupLayout.BrandMissMatch,
    hasCancelButton: false,
    allowBackgroundClose: false,
    onClose: () => {
      SiteConfigStore.reset();
      appContext.authStore.logout();
    },
  };

  useEffect(() => {
    popupStore.initialize(template && template === 'brandMissMatch' ? brandMissMatchPopupConfig : popupConfig);
    popupStore.changeIsOpen(true);
  }, []);

  return <Popup popupStore={popupStore} />;
});

export default WelcomeScreen;